export enum PSBErrors {
  NoBookingInModule = "Booking not found in module",
  HasNoPSS = "Booking has no pss",
  HasNoEnoughPSS = "Booking doesn't have enough pss to remove",
  HasNoAccounting = "Booking has no accounting",
  HasNoAccountingEntries = "BOOking has no accounting entries",
  HasNoUUID = "Booking has no UUID",
  NoPriceInBooking = "Booking doesn't include searched price",
  NoSelectedBookingInModule = "Module doesn't have a selected booking",
}
